import React from "react";
import ReactDOM from "react-dom";
import App from "./App"; // ts-loader and typescript modules needed!


ReactDOM.render(<App />, document.getElementById("root-lib"));
